import React, { useRef, useState, useCallback } from 'react';
import './../styles/home.css'
import pointer from "./../assets/svg/pointer.svg"
import download from "./../assets/svg/download.svg"
import firstPageImage from "./../assets/svg/first_page_image.svg"
import aboutWords from "./../assets/svg/about_words.svg"
import contact_chars from "./../assets/svg/contact_chart.svg"
import keyboard from "./../assets/svg/keyboard.svg"
import small_mail from "./../assets/svg/small_mail.svg"
import send_message from "./../assets/svg/send_message.svg"
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ProjectCard from "./../components/ProjectCard"
import skudrop from "./../assets/images/skudrop.png"
import cloud_order from "./../assets/images/co.png"
import musopen from "./../assets/images/musopen.png"
import mockmate from "./../assets/images/mockmate.png"
import pointer2 from "./../assets/svg/pointer2.svg"
import light from "./../assets/svg/light.svg"
import laptop from "./../assets/svg/laptop.svg"
import music from "./../assets/svg/music.svg"
import down from "./../assets/svg/down.svg"
import noimage from "./../assets/images/noimage.png"
import SkillCard from '../components/SkillCard';
import colored_laptop from "./../assets/svg/colored_laptop.svg"
import emailjs from "@emailjs/browser"
import autumna from "./../assets/svg/autumna.svg"
import openscore from "./../assets/images/openscore.png"
import dad from "./../assets/images/dad.png"

const enableSubmitButton = () => {
  // setIsButtonDisabled(false);
  document.getElementById("button-id").disabled = false;
  document.getElementById("button-id").removeAttribute("disabled")
};
function Home() {
  const [formData, setFormData] = useState({
    from_name: '',
    from_email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };



  const [isButtonDisabled, setIsButtonDisabled] = useState(true);




  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_69qxvyi', 'template_jh180jb', e.target, '-OcaUpYsnHmDVaGSS')
      .then((result) => {
        const message = document.getElementById("message");
        message.disabled = "true";

        const name = document.getElementById("from_name");
        name.disabled = "true";

        const email = document.getElementById("from_email");
        email.disabled = "true";

        const button = document.getElementById("button-id");
        button.disabled = "true";

        const text_b = document.getElementById("button-text");
        text_b.innerText = "Message sent.";
        const icon = document.getElementById("button-icon")
        icon.style.display = "none"
        // console.log(result.text);
      }, (error) => {
        // console.log(error.text);
      });

  };

  const currentYear = new Date().getFullYear();
  const experienceYears = currentYear - 2019;

  return (
    <>
      <section className="home-section">
        <div className="container-fluid" id="home_id">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-7 vh-100">
              <div className="row align-items-center d-flex justify-content-center h-100">
                <img src={pointer} className='pointer-image'></img>
                <div className="content-right home-main">
                  <span className="d-flex justify-content-center main-text">Roman Boba</span>
                  <span className="d-flex justify-content-center main-text blue-text mb-4">PYTHON DEVELOPER</span>
                  <div className='row m-0'>
                    <button className='hire-me-button'><a href="#contact_id" style={{ color: "white", textDecoration: "none" }}>Hire me</a></button>
                    <a href="cv.pdf" download="roman_boba_cv.pdf" className='download-sv-a'>
                      <button className='cv-button'>
                        Download CV <img src={download} className='download-svg'></img>
                      </button>
                    </a>
                  </div>
                  <div className='down-button'>
                    <a href="#about_id"><img src={down} alt="" /></a></div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 vh-100 home-image">
              <div className='row align-items-center d-flex justify-content-center h-100'>
                <img src={firstPageImage} className='first-page-image'></img>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="" id="about_id">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 vh-100 d-flex justify-content-center position-relative">
              <div className="about-half-text">
                <div className="about-me-header">
                  <span className="d-flex title-about-me me-4">About</span>
                  <span className="about-me-blue-text title-about-me blue-text me-4">me</span>
                  <img src={light} className='light-for-about2'></img>
                </div>
                <div className='d-flex about-text'>
                  <span >As an experienced Python Backend Developer with {experienceYears} years of commercial experience, I have a strong track record of delivering robust and scalable solutions. With strong problem-solving skills and attention to detail, I am committed to creating innovative solutions that meet your business needs. Let's collaborate to
                    bring your project to life!
                  </span>
                </div>
              </div>
              <img src={light} className='light-for-about1'></img>
              <img src={pointer2} className='about-pointer'></img>
              <img src={music} className='about-music'></img>
            </div>
            <div className="col-lg-6 vh-100 about-second">
              <div className='row align-items-center d-flex justify-content-center h-75'>
                <img src={aboutWords} className='about-me-image'></img>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mb-5" id="skills_id">
        <div className="container-fluid">
          <div className="row">
            <div className="d-flex justify-content-center full-size-skills">
              <div className="d-flex flex-column justify-content-center projects-width w-100 position-relative">
                <div className="d-flex content-right" style={{ alignItems: "center" }}>
                  <span className="d-flex title-projects-me">Ski</span>
                  <span className="d-flex title-projects-me blue-text">lls</span>
                  <img src={colored_laptop} className='laptop-small' />
                </div>

                <div className='skills-area position-relative'>
                  <SkillCard name="Backend" stack={["python", "django", "pandas", "tensorFlow", "ElasticSearch/OpenSearch", "pydantic", "celery", "FastAPI", "flask",]} />

                  <SkillCard name="Cloud & DevOps" stack={["kubernetes", "helm", "docker", "Azure", "Azure Container Registry", "Azure Durable Functions", "grafana", "AWS", "heroku"]} />

                   <SkillCard name="Databases" stack={["MSSQL", "postgreSQL", "redis", "mySQL",  "firebase"]} />
                  
                  <SkillCard name="Front-End, UI & Marketing/SEO" stack={["react", "Google Tag Manager", "SEO", "JS", "HTML", "CSS", "jinja2",]} />

                  <SkillCard name="APIs" stack={["OpenAI", "shopify", "facebook", "docuSign", "tiktok", "linkedin", "stripe", "instagram", "paypal", "google Search", "Amazon SP-API",]} />

                  <SkillCard name="Knowledge" stack={["MCP", "Single Sign-On (SSO)", "digitalOcean", "git", "github", "RabbitMQ", "beautifulSoup", "nginx",]} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="projects-background" id="projects_id">
        <div className="container-fluid">
          <div className="row">
            <div className="d-flex justify-content-center full-size-projects">
              <div className="d-flex flex-column justify-content-center projects-width">
                <div className="d-flex content-right mb-4">
                  <span className="title-projects-me">My recent <span className="title-projects-me2 blue-text"> projects</span></span>
                  
                </div>
                <div className='projects-area'>
                  <ProjectCard link="https://www.autumna.co.uk/" image={autumna} name="Autumna" stack={
                    [
                      "python",
                      "django",
                      "kubernetes",
                      "helm",
                      "astro",
                      "Azure Functions",
                      "ElasticSearch/OpenSearch",
                      "MSSQL",
                      "redis",
                      "docker",
                      "Google Tag Manager",
                      "SEO",
                      "Azure DevOps",
                      "Azure Container Registry",
                      "grafana",
                    ]
                    } phase="Prod" description="Autumna is the UK’s largest and most comprehensive directory for later-life living and elderly care. Leveraging an open-source search and analytics suite, it applies advanced caching strategies and aggregates data from multiple sources to generate the most accurate and relevant scores for care centres." />
                  <ProjectCard link="https://api.openscore.org.uk/widget/view/1-1/" image={openscore} name="OpenScore" stack={
                    [
                      "python",
                      "django",
                      "kubernetes",
                      "helm",
                      "MSSQL",
                      "docker",
                      "redis",
                      "Azure DevOps",
                      "Azure Container Registry",
                      "grafana",
                    ]
                  } phase="Prod" description="OpenScore is a groundbreaking initiative designed to bring unprecedented transparency and insight to the care sector. Working in close collaboration with Autumna, OpenScore collects and analyses a wide range of data points to generate the most accurate and reliable care scores available." />
                  <ProjectCard link="https://www.dad.autumna.co.uk/" image={dad} name="DAD" stack={
                    [
                      "python",
                      "django",
                      "jinja2",
                      "kubernetes",
                      "helm",
                      "MSSQL",
                      "Single Sign-On (SSO)",
                      "docker",
                      "Azure DevOps",
                      "Azure Container Registry",
                      "grafana",
                    ]
                  } phase="Prod" description="DAD is the only system that delivers real-time care availability for hospital discharge and brokerage teams, cutting the time to identify suitable care from days to just 60 minutes." />


                  <ProjectCard link="https://www.skudrop.com" image={skudrop} name="SKUdrop" stack={["python", "django", "react", "docker", "AWS", "postgreSQL", "docusign", "redis", "Amazon SP-API", "google", "payPal", "pandas", "stripe", "jinja2", "github",]} phase="Prod" description="SKUdrop manages the flow of cartons between your supplier's factory and Amazon FBA. Provide cost-effective storage in China, direct-to-Amazon shipping options, and software designed to save you time and money." />
                  <ProjectCard link="https://cloudorder.us/" image={cloud_order} name="CloudOrder" stack={["python", "django", "react", "docker", "AWS", "shopify", "payPal", "postgreSQL", "Amazon SP-API", "redis", "stripe", "google", "celery", "github"]} phase="Prod" description="An E-Commerce marketplace that connects retailers with brand suppliers, dropshipping style.Retail stores focus on marketing. CloudOrder takes care of the logistics. Brands focus on product development." />
                  <ProjectCard link="https://musopen.org/" image={musopen} name="Musopen" stack={["python", "AWS", "mySQL", "docker", "django", "firebase", "payPal", "jinja2", "github",]} phase="Prod" description="Musopen allows users to learn and teach musical instruments, with class organization, payments, parental controls, the ability to publish sheet music and listen to the radio." />
                  
                  {/* 
                    <ProjectCard link="" image={noimage} name="Establish" stack={["python", "docker", "AWS", "react", "facebook", "tikTok", "linkedIn", "postgreSQL", "instagram", "django", "google", "github"]} phase="Frozen" description="Establish is project is focused on data analysis with the integration of social networks, using such services as Instagram, Facebook, LinkedIn, TikTok, Google Search." />
                    <ProjectCard link="https://mockmate.com/" image={mockmate} name="Mockmate" stack={["python", "TensorFlow", "flask", "heroku", "postgreSQL", "JS", "HTML", "CSS", "github"]} phase="Prod" description="Mockmate helps job seekers (and companies) get jobs faster by automating interviews with analyzing user's audio, video, and text responses to the interview using machine learning in real-time helps recruiters get a detailed overview of the interview result. Using artificial intelligence and natural language processing, everyone can interview and get objective analysis." />
                    <ProjectCard link="" image={noimage} name="Quilly" stack={["python", "docker", "JS", "jinja2", "django", "git", "github", "digitalOcean",]} phase="Frozen" description="Quilly is a B2B project oriented for owners of websites who need to collect user feedback from their web pages, special Quilly widget makes it possible and allows clients to place it on any page they need and collect all feedback on Quilly dashboards." /> 
                  */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mt-4" id="contact_id">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 contact-first-section">
              <div className='row contact-header-section'>
                <div className="content-right">
                  <span className="contact-chart-text">Got a project in<span className="contact-chart-text2 blue-text">mind?</span></span>
                  
                </div>
                <div className="contact-charts">
                  <img src={contact_chars} className=''></img>
                </div>

              </div>
            </div>
            <div className="col-lg-6 vh-100 d-flex justify-content-center" id="email-sending-form">
              <div className="contact-form-area">
                <Form onSubmit={handleSubmit}>
                  <div className='d-flex gap-4'>
                    <Form.Group className="mb-3 w-100" >
                      <Form.Label className='label-input'>Your name</Form.Label>
                      <Form.Control id="from_name" onChange={handleChange} value={formData.from_name} required name="from_name" className='name-input' type="text" placeholder="Name" />
                    </Form.Group>
                    <Form.Group className="mb-3 w-100" >
                      <Form.Label className='label-input'>Email address</Form.Label>
                      <Form.Control id="from_email" onChange={handleChange} value={formData.from_email} required name="from_email" className='email-input' type="email" placeholder="Email" />
                    </Form.Group>
                  </div>

                  <Form.Group className="mb-3" >
                    <Form.Label className='label-input'>Your Message</Form.Label>
                    <Form.Control id="message" onChange={handleChange} value={formData.message} required name="message" className='text-area-message' as="textarea" rows={7} placeholder='Message' />
                  </Form.Group>
                  <div className=''>
                    <Button variant="primary" type="submit" className='send-button' id="button-id">
                      <span id="button-text" className='sent-button-text'>Send Message </span>
                      <img src={send_message} className='send-icon' id="button-icon"></img>
                    </Button>
                  </div>
                </Form>


                <img src={small_mail} className='send-icon-mail position-absolute'></img>
                <img src={small_mail} className='position-absolute small-email-image-bottom'></img>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};


export default Home;
